export default __webpack_public_path__ + "static/media/Feed.de80b882.jpg";